export default __webpack_public_path__ + "static/media/vision-care.745b6e2d.png";